export const calculateAmount = (typeOffre, categoriePremium) => {
  if (typeOffre === 1 && !categoriePremium) return 2000;
  if (typeOffre === 1 && categoriePremium) return 4000; 
  if (typeOffre === 2 && !categoriePremium) return 5000;
  if (typeOffre === 2 && categoriePremium) return 10000;
  return 2000;
};


// Type 1: Prix Standard - Categorie Standard => 2000 
// Type 2: Prix Standard - Categorie Premium => 4000 
// Type 3: Prix Premium - Categorie Standard => 5000 
// Type 4: Prix Premium - Categorie Premium => 10000 

// CONDITIONS
// Prix Standard => nbr Photo max 2
// Prix Premium => nbr Photo max 10